import * as Utils from "@/utils.js";
import apiClient from "./Environment";

export default {
  getHotels() {
    return apiClient.get("/get-hotels-resume");
  },
  getAvailableMonths(hotel_id, section, vs, hotel_vs) {
    return apiClient.post("/get-available-months-by-section", {
      hotel_id: hotel_id,
      section: section,
      vs: vs,
      hotel_vs: hotel_vs
    });
  },
  getAllHotels() {
    return apiClient.get("/get-app-hotels");
  },
  modifyHotel(hotel) {
    return apiClient.post("/set-app-hotel", { hotel: hotel });
  },
  createHotel(hotel) {
    return apiClient.post("/create-app-hotel", { hotel: hotel });
  },
  activateHotel(hotel_id) {
    return apiClient.post("/activate-hotel", { hotel_id });
  },
  deactivateHotel(hotel_id) {
    return apiClient.post("/deactivate-hotel", { hotel_id });
  },
  getCurrencyConversionPeriodsHotel(hotel_id) {
    return apiClient.post("/get-currency-conversions-hotel", { hotel_id });
  },
  setCurrencyConversionPeriodsHotel(data) {
    return apiClient.post("/set-currency-conversions-hotel", data);
  },
  getSiteminderHotels() {
    return apiClient.get("/get-siteminder-hotels");
  },
  getBoards(params) {
    return apiClient.get("/get-boards" + Utils.buildGetParams(params));
  },
  getIsUpdatingSellpar(hotel_id) {
    return apiClient.get("/is-updating-sellpar", { params: { hotel_id } });
  },
  getTaskStatus(hotel_id, task_id) {
    return apiClient.get("/get-task-status", {
      params: { hotel_id, task_id }
    });
  }
};
